import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-705a1a26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-row align-items-center" }
const _hoisted_2 = {
  key: 0,
  class: "position-buttons text-primary p-2 mr-2"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-bars panel-drag-handle" }, null, -1))
const _hoisted_4 = {
  key: 1,
  class: "flex-grow-1"
}
const _hoisted_5 = { class: "m-0 flex-grow-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_AnimatedInput = _resolveComponent("AnimatedInput")!
  const _component_Dialog = _resolveComponent("Dialog")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, {
    id: _ctx.id,
    class: "flat border p-4"
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.disabled)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("i", {
                class: "pi pi-caret-up",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('move-up'))),
                style: _normalizeStyle({ opacity: _ctx.canMoveUp ? '1' : '0' })
              }, null, 4),
              _hoisted_3,
              _createElementVNode("i", {
                class: "pi pi-caret-down",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('move-down'))),
                style: _normalizeStyle({ opacity: _ctx.canMoveDown ? '1' : '0' })
              }, null, 4)
            ]))
          : _createCommentVNode("", true),
        (_ctx.field)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("h5", _hoisted_5, _toDisplayString(_ctx.field.name), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.disabled)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 2,
              class: "mr-2",
              icon: "pi pi-pencil",
              onClick: _ctx.openEditDialog
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.disabled)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 3,
              icon: "pi pi-trash",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('remove')))
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    content: _withCtx(() => [
      _createVNode(_component_Dialog, {
        header: _ctx.i18n.$gettext('Feld bearbeiten'),
        visible: _ctx.showEditFolderDialog,
        "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showEditFolderDialog) = $event)),
        onHide: _ctx.resetDialogues,
        modal: ""
      }, {
        footer: _withCtx(() => [
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Abbrechen'),
            icon: "pi pi-times",
            class: "p-button-text",
            onClick: _ctx.resetDialogues
          }, null, 8, ["label", "onClick"]),
          _createVNode(_component_Button, {
            label: _ctx.i18n.$gettext('Speichern'),
            icon: "pi pi-check",
            autofocus: "",
            disabled: !_ctx.editedName,
            onClick: _ctx.acceptChanges
          }, null, 8, ["label", "disabled", "onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.editedName,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editedName) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Feld-Name'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"]),
          _createVNode(_component_AnimatedInput, {
            modelValue: _ctx.editedPrefill,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.editedPrefill) = $event)),
            "auto-resize": "",
            label: _ctx.i18n.$gettext('Vorausbelegung'),
            class: "mb-4"
          }, null, 8, ["modelValue", "label"])
        ]),
        _: 1
      }, 8, ["header", "visible", "onHide"])
    ]),
    _: 1
  }, 8, ["id"]))
}